export default {"src":"/_next/static/media/tribune-toeschouwers-plek.a896044d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};